import { Middleware } from '@reduxjs/toolkit';

const sanitizePayload = (payload: unknown): Record<string, unknown> => {
  if (payload === undefined) return {};
  if (typeof payload !== 'object' || payload === null) return { value: payload };

  const { password, ...rest } = payload as Record<string, unknown>;
  return rest;
};

export const klaviyoMiddleware: Middleware = () => (next) => (action) => {
  // Send every action to Klaviyo
  if (typeof _learnq !== 'undefined' && action.type) {
    const properties = sanitizePayload(action.payload);
    _learnq.push(['track', action.type, properties]);
  }

  return next(action);
};
